import { render } from "./periodHistorty.vue?vue&type=template&id=899fcd90"
import script from "./periodHistorty.vue?vue&type=script&lang=js"
export * from "./periodHistorty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__